import Stack from '@mui/material/Stack'
import Box from '@mui/system/Box'
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import { changeCurrentZoneIndexesFunc } from 'containers/VerticalPage/common/utils'
import Details from 'containers/VerticalPage/company-overview/Details/Details'
import React, { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { selectCurrentZone } from 'store/global'
import { VerticalContext } from 'store/verticals/Context'
import VerticalDetailsContextProvider from 'store/verticalsDetails/Context'
import { CurrentZone } from 'utils/types'
import styles from './styles'
import LinearProgress from '@mui/material/LinearProgress'
import { overviewMapping } from './utils'
import { useQuery } from '@tanstack/react-query'
import { OverviewV2 } from '../../../../components/OverviewV2'
import { NetworkGraphButton } from 'components/network-graph/NetworkGraphButton'
// TODO: this and nexus VerticalPage are the same, should unite them.
const VerticalPage = ({ changeCurrentZoneIndexes }: { changeCurrentZoneIndexes: changeCurrentZoneIndexesFunc }) => {
  const currentZone: CurrentZone = useSelector(selectCurrentZone)
  const { getVerticalEntity, verticalEntity } = useContext(VerticalContext)
  const { caseId } = useParams<{ caseId: string }>()
  const companyOverviewIndices = currentZone?.companyOverviewIndices
  const { isLoading } = useQuery({
    queryKey: [caseId, companyOverviewIndices],
    enabled: !!companyOverviewIndices && !!caseId,
    queryFn: async () => {
      return (await getVerticalEntity(caseId, companyOverviewIndices as string)) || null
    },
  })

  useEffect(() => {
    changeCurrentZoneIndexes({
      baseIndices: currentZone?.companyOverviewIndices,
      activityIndices: currentZone?.companyOverviewActivityIndices,
      employeeIndices: currentZone?.companyOverviewActivityIndices,
    })
  }, [currentZone, changeCurrentZoneIndexes])

  return (
    <Stack>
      <OverviewV2
        descriptor={verticalEntity?.overviewDetails.industry}
        overviewMapping={overviewMapping}
        breadcrumbs={
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Breadcrumbs
              containerSx={styles.breadcrumbsStyles}
              data={[
                { label: 'Home', href: '/' },
                { label: 'Company Overview', href: '/company-overview' },
                { label: verticalEntity?.entityDetails?.name || 'N/A' },
              ]}
            />
            <NetworkGraphButton />
          </Box>
        }
      />
      <Stack sx={styles.container}>
        {isLoading && !verticalEntity && (
          <>
            <LinearProgress sx={styles.Loader} />
            <Box sx={styles.LoaderOverlay} />
          </>
        )}
        <VerticalDetailsContextProvider>
          <Details />
        </VerticalDetailsContextProvider>
      </Stack>
    </Stack>
  )
}

export default VerticalPage
